import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!username || !password) {
      toast.error("Enter username and password");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(`${API}/admin/login`, {
        username,
        password,
      });

      localStorage.setItem("admin_token", res.data.access_token);
      toast.success("Login successful");
      navigate("/admin");
    } catch (err) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-void">
      <div className="glass-card p-8 w-full max-w-md">
        <h1 className="font-unbounded text-2xl text-white mb-6">
          Admin Login
        </h1>

        <input
          className="w-full mb-4 p-3 rounded bg-white/5 text-white border border-white/10"
          placeholder="Username"
          onChange={(e) => setUsername(e.target.value)}
        />

        <input
          type="password"
          className="w-full mb-6 p-3 rounded bg-white/5 text-white border border-white/10"
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
        />

        <button
          onClick={handleLogin}
          disabled={loading}
          className="w-full py-3 rounded bg-electric-violet text-white font-medium hover:opacity-90"
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
